import React from "react";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  icon: LucideIcon;
  label: string;
  value: number | string;
  hint?: string;
}

const StatCard = ({ icon: Icon, label, value, hint }: StatCardProps) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-5 flex justify-between items-center hover:shadow-lg transition-shadow duration-300">
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="text-2xl font-semibold text-[#1E1E1E]">{value}</p>
        {hint && <p className="text-xs text-gray-400 mt-1 line-clamp-2">{hint}</p>}
      </div>
      <div className="bg-[#EDE3F7] p-3 rounded-full text-[#885ABB]">
        <Icon size={24} />
      </div>
    </div>
  );
};

export default StatCard;
